// import { useIntegration } from '@tma.js/react-router-integration';
import {
  bindMiniAppCSSVars,
  bindThemeParamsCSSVars,
  bindViewportCSSVars,
  // initNavigator,
  useLaunchParams,
  useMiniApp,
  useThemeParams,
  // useViewport,
} from '@tma.js/sdk-react';
import { AppRoot } from '@telegram-apps/telegram-ui';
import {
  type FC,
  useEffect,
  // useMemo
} from 'react';
import {
  // Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import { Homepage } from './pages/Homepage';
import { GreenCard } from './pages/GreenCard/GreenCard';
import { OrderPage } from './pages/Order/OrderPage';
import { Payment } from './pages/Payment/PaymentPage';
import { PaymentConfirm } from './pages/Payment/PaymentConfirm';
import { Rovignette } from './pages/Rovignette/Rovignette';
import { Rca } from './pages/RCA/Rca';
// import { viewport } from '@telegram-apps/sdk';

export const App: FC = () => {
  const lp = useLaunchParams();
  const miniApp = useMiniApp();
  const themeParams = useThemeParams();
  // const viewport = useViewport();

  useEffect(() => {
    return bindMiniAppCSSVars(miniApp, themeParams);
  }, [miniApp, themeParams]);

  useEffect(() => {
    return bindThemeParamsCSSVars(themeParams);
  }, [themeParams]);

  // if (viewport.requestFullscreen.isAvailable()) {
  //   viewport.requestFullscreen();
  // }
  // useEffect(() => {
  //   return viewport && bindViewportCSSVars(viewport);
  // }, [viewport]);

  // Create a new application navigator and attach it to the browser history, so it could modify
  // it and listen to its changes.
  // const navigator = useMemo(() => initNavigator('app-navigation-state'), []);
  // const [location, reactNavigator] = useIntegration(navigator);

  // // Don't forget to attach the navigator to allow it to control the BackButton state as well
  // // as browser history.
  // useEffect(() => {
  //   navigator.attach();
  //   return () => navigator.detach();
  // }, [navigator]);
  return (
    <AppRoot
      appearance={miniApp.isDark ? 'dark' : 'light'}
      platform={['macos', 'ios'].includes(lp.platform) ? 'ios' : 'base'}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/green-card" element={<GreenCard />} />
          <Route path="/rovignette" element={<Rovignette />} />
          <Route path="/rca" element={<Rca />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment-confirm" element={<PaymentConfirm />} />
        </Routes>
      </Router>
    </AppRoot>
  );
};
